import { render, staticRenderFns } from "./RealEstateAccommodationView.vue?vue&type=template&id=99bda80c&"
import script from "./RealEstateAccommodationView.vue?vue&type=script&lang=js&"
export * from "./RealEstateAccommodationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports